// Waarom een registratie niet meetelt in de bespaarde CO2 en de besparing op
// de energierekening — in gewone taal, met wat de organisatie eraan kan doen.
// De statussen komen uit resolveMaterialIntervention / computeMaterialImpact,
// plus 'needs-date' uit buildMaterialOutcomes.
// AI-CONTEXT: See docs/features/materiaal-uitkomsten-tegels.md

const REASONS = {
    'unmapped': {
        label: 'Niet gekoppeld aan een maatregel',
        action: "Kies bij het materiaal bij 'Hoort bij' de maatregel, als het een energiemaatregel is. Hulpmiddelen zoals magneten of gereedschap tellen terecht niet mee.",
    },
    'unknown-code': {
        label: 'Onbekende maatregelcode',
        action: "Kies bij het materiaal bij 'Hoort bij' opnieuw de maatregel.",
    },
    'needs-factor': {
        label: 'Omrekening ontbreekt',
        action: 'Vul bij het materiaal in hoeveel er in één product zit, bijvoorbeeld hoeveel meter in één pak.',
    },
    'needs-residents': {
        label: 'Aantal bewoners ontbreekt',
        action: "Vul op het tabblad 'Gegevens' van het huishouden het 'Aantal bewoners' in.",
    },
    'needs-quantity': {
        label: 'Aantal ontbreekt',
        action: 'Vul bij de registratie op het huishouden het aantal in.',
    },
    'needs-date': {
        label: 'Registratiedatum ontbreekt',
        action: 'Vul bij de registratie op het huishouden de datum in.',
    },
    'no-kengetal': {
        label: 'De meetstandaard heeft hier geen getal voor',
        action: 'Hier kun je niets aan doen: de meetstandaard publiceert (nog) geen besparing voor deze maatregel.',
    },
}

/**
 * @param {string} status
 * @returns {{label: string, action: string}} Een onbekende status toont zichzelf, zodat hij niet wegvalt
 */
const unknownReason = (status) => REASONS[status] || { label: status || '', action: '' }

export default unknownReason
